import React from 'react';
import { ModalTitleView } from '../../common/components';
export default [
    {
        key: 'LogModal',
        getComponent: function () { return import('./LogModal'); },
        title: '下发记录',
        width: 800,
    },
    {
        key: 'ManualDistributeModal',
        getComponent: function () { return import('./ManualDistributeModal'); },
        title: (React.createElement(ModalTitleView, { title: i18n.get('角色'), subTitle: i18n.get('(注：已下发角色不可下发)') })),
        width: 600,
        maskClosable: false,
        wrapClassName: 'vertical-center-modal select-member-modal',
    },
];
